import { getContentType, getLanguae, getSearchCountry, getCmsDomain } from 'common/util'
import { has, isArray, isString, omit, pick } from 'lodash'
import request, { ResponseData } from './request'

const Omits = ['createdAt', 'locale', 'pn', 'publishedAt', 'updatedAt', 'banner', 'tabs']

export enum IGuideComponentType {
  Feature = 'global.tutorial-feature',
  Video = 'global.tutorial-video-tab',
  Banner = 'global.tutorial-banner',
  Sku = 'global.tutorial-sku',
  Community = 'global.tutorial-community',
}

export enum IGuideFeatureLayout {
  Vertical = 'vertical',
  Grid = 'grid',
}

export interface IGuideFeature {
  id: number
  layout: string
  title: string
  __component: string
  listing: Array<{
    icon?: string
    id: number
    title: string
    value: string
  }>
  isShowSeeAll?: boolean
  link?: string
  moreTitle?: string
}

export interface IGuideVideo {
  id: number
  title: string
  __component: string
  listing: Array<{
    description: string | null
    id: number
    title: string
    value: string
  }>
  isShowSeeAll?: boolean
  link?: string
  moreTitle?: string
}

export interface IGuideBanner {
  id: number
  title: string
  layout: string
  __component: string
  listing: Array<{
    banner: string
    id: number
    title: string
    value: string
  }>
  isShowSeeAll?: boolean
  link?: string
  moreTitle?: string
}

export interface IGuideSku {
  id: number
  title: string
  store: string
  __component: string
  listing: Array<string>
  isShowSeeAll?: boolean
  link?: string
  moreTitle?: string
}

export interface IGuideCommunity {
  id: number
  title: string
  __component: string
  listing: Array<string>
  isShowSeeAll?: boolean
  link?: string
  moreTitle?: string
}

export interface IGuide {
  // start_ai_generated
  id: string
  // end_ai_generated
  locale:string
  title: string
  banner: Array<{ url: string; name: string }>
  tabs: Array<IGuideBanner | IGuideCommunity | IGuideFeature | IGuideSku | IGuideVideo>
}

interface GetGuideResponse {
  data: {
    data: {
      id: number
      attributes: {
        title: string
        banner: {
          data: Array<{
            id: number
            attributes: {
              url: string
              name: string
            }
          }>
        }
        tabs: Array<
          {
            __component: string
            id: number
            title: string
            listing: any
          } & { [k: string]: any }
        >
      }
    }
  }
}

const getGuide = async (params: { id?: string; pn?: string }) => {
  const content_type = await getContentType()
  const lang = getLanguae()
  const country = getSearchCountry()
  // const DEPLOY_REGION = getDeployRegion()

  // /wiki/nav 使用getCmsDomain更改host 后期统一替换

  // const link =
  //   DEPLOY_REGION === 'CN'
  //     ? `${await getAppDomain()}/v1/cms_service/cms/product/wiki/nav`
  //     : `${await getAppDomain()}/v1/shopping/cms/product/wiki/nav/1.1.0`

  // const method = DEPLOY_REGION === 'US' ? 'GET' : 'POST'
  // const getParams = DEPLOY_REGION === 'US' ? _params : undefined
  // const postParams = DEPLOY_REGION === 'US' ? undefined : _params

  const link = `${await getCmsDomain()}/v1/cms_service/cms/product/wiki/nav`
  const _params = { ...params, content_type: content_type.guide, lang, country }
  return request<ResponseData<GetGuideResponse>>(
    link,
    {
      method: 'POST',
      // params: getParams,
      data: _params,
    },
    {
      ignoreAuthToken: true,
    }
  )
    .then(res => {
      if (res.code === 0 && has(res, 'data.data.data.attributes')) {
        if (!params.id) {
          params.id = String(res.data.data.data.id) ?? ''
        }
        return res.data.data.data.attributes
      } else {
        return Promise.reject(null)
      }
    })
    .then(res => {
      let { banner: _banner, tabs: _tabs ,locale } = res

      // banner 处理
      const banner = _banner.data?.map((item: { attributes: any }) => pick(item.attributes, ['url', 'name'])) || []

      // tabs 处理
      const tabs = _tabs.map((item: any) => {
        // Feature
        if (item.__component === IGuideComponentType.Feature) {
          if (item.listing && isArray(item.listing)) {
            item.listing = item.listing.map((feature: { icon: { data: { attributes: { url: any } } } }) => {
              feature.icon = feature.icon.data?.attributes.url
              return feature
            })
          }
        }

        // Banner
        if (item.__component === IGuideComponentType.Banner) {
          if (item.listing && isArray(item.listing)) {
            item.listing = item.listing.map((feature: { banner: { data: { attributes: { url: any } } } }) => {
              feature.banner = feature.banner.data?.attributes.url
              return feature
            })
          }
        }

        // Sku
        if (item.__component === IGuideComponentType.Sku) {
          if (item.listing && isString(item.listing)) {
            JSON.parse(item.listing || '[]').map((one: { store: string }) => {
              // start_ai_generated
              item.store = one.store
              // end_ai_generated
              return one
            })
            item.listing = JSON.parse(item.listing || '[]').map((one: { sku: string }) => one.sku)
          }
        }

        // Community
        if (item.__component === IGuideComponentType.Community) {
          if (item.listing && isString(item.listing)) {
            item.listing = item.listing.split(';')
          }
        }

        return item
      })
      return { id: params.id, banner, locale,tabs, ...omit(res, Omits) } as IGuide
    })
}

export default getGuide
